// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WhyRouteImport } from './routes/why'
import { Route as VisionRouteImport } from './routes/vision'
import { Route as ValuesRouteImport } from './routes/values'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SupportRouteImport } from './routes/support'
import { Route as StoryRouteImport } from './routes/story'
import { Route as SafetyRouteImport } from './routes/safety'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RefundsRouteImport } from './routes/refunds'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ParentsRouteImport } from './routes/parents'
import { Route as LoginRouteImport } from './routes/login'
import { Route as FounderRouteImport } from './routes/founder'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CharactersRouteImport } from './routes/characters'
import { Route as AgeRatingRouteImport } from './routes/age-rating'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ValuesCodeRouteImport } from './routes/values.$code'
import { Route as ParentsSlugRouteImport } from './routes/parents.$slug'
import { Route as CharactersCodeRouteImport } from './routes/characters.$code'
import { Route as AuthenticatedParentConsentRouteImport } from './routes/_authenticated/parent-consent'
import { Route as AuthenticatedOnboardingRouteImport } from './routes/_authenticated/onboarding'
import { Route as AuthenticatedAppRouteImport } from './routes/_authenticated/app'
import { Route as AuthenticatedAppIndexRouteImport } from './routes/_authenticated/app/index'
import { Route as AuthenticatedAppSettingsRouteImport } from './routes/_authenticated/app/settings'
import { Route as AuthenticatedAppPricingRouteImport } from './routes/_authenticated/app/pricing'
import { Route as AuthenticatedAppParentRouteImport } from './routes/_authenticated/app/parent'
import { Route as AuthenticatedAppBillingRouteImport } from './routes/_authenticated/app/billing'
import { Route as AuthenticatedAppAdminIndexRouteImport } from './routes/_authenticated/app/admin.index'
import { Route as AuthenticatedAppWatchIdRouteImport } from './routes/_authenticated/app/watch.$id'
import { Route as AuthenticatedAppChildNewRouteImport } from './routes/_authenticated/app/child.new'
import { Route as AuthenticatedAppChildChildIdRouteImport } from './routes/_authenticated/app/child.$childId'
import { Route as AuthenticatedAppAdminTeamRouteImport } from './routes/_authenticated/app/admin.team'
import { Route as AuthenticatedAppAdminSubscriptionsRouteImport } from './routes/_authenticated/app/admin.subscriptions'
import { Route as AuthenticatedAppAdminSubscribersRouteImport } from './routes/_authenticated/app/admin.subscribers'
import { Route as AuthenticatedAppAdminReviewRouteImport } from './routes/_authenticated/app/admin.review'
import { Route as AuthenticatedAppAdminRevenueRouteImport } from './routes/_authenticated/app/admin.revenue'
import { Route as AuthenticatedAppAdminNurtureRouteImport } from './routes/_authenticated/app/admin.nurture'
import { Route as AuthenticatedAppAdminLaunchRouteImport } from './routes/_authenticated/app/admin.launch'
import { Route as AuthenticatedAppAdminFeedbackRouteImport } from './routes/_authenticated/app/admin.feedback'
import { Route as AuthenticatedAppAdminIdRouteImport } from './routes/_authenticated/app/admin.$id'
import { Route as AuthenticatedAppParentTodayRouteImport } from './routes/_authenticated/app/parent.today'
import { Route as AuthenticatedAppParentThisWeekRouteImport } from './routes/_authenticated/app/parent.this-week'
import { Route as AuthenticatedAppChildChildIdStoriesRouteImport } from './routes/_authenticated/app/child.$childId.stories'
import { Route as AuthenticatedAppChildChildIdRewardsRouteImport } from './routes/_authenticated/app/child.$childId.rewards'
import { Route as AuthenticatedAppChildChildIdQuietRouteImport } from './routes/_authenticated/app/child.$childId.quiet'
import { Route as AuthenticatedAppChildChildIdJourneyRouteImport } from './routes/_authenticated/app/child.$childId.journey'
import { Route as AuthenticatedAppChildChildIdEditRouteImport } from './routes/_authenticated/app/child.$childId.edit'
import { Route as AuthenticatedAppChildChildIdChallengesRouteImport } from './routes/_authenticated/app/child.$childId.challenges'
import { Route as AuthenticatedAppChildChildIdStoriesStoryIdRouteImport } from './routes/_authenticated/app/child.$childId.stories.$storyId'

const WhyRoute = WhyRouteImport.update({
            id: '/why',path: '/why',getParentRoute: () => rootRouteImport
          })
const VisionRoute = VisionRouteImport.update({
            id: '/vision',path: '/vision',getParentRoute: () => rootRouteImport
          })
const ValuesRoute = ValuesRouteImport.update({
            id: '/values',path: '/values',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SupportRoute = SupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => rootRouteImport
          })
const StoryRoute = StoryRouteImport.update({
            id: '/story',path: '/story',getParentRoute: () => rootRouteImport
          })
const SafetyRoute = SafetyRouteImport.update({
            id: '/safety',path: '/safety',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RefundsRoute = RefundsRouteImport.update({
            id: '/refunds',path: '/refunds',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ParentsRoute = ParentsRouteImport.update({
            id: '/parents',path: '/parents',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const FounderRoute = FounderRouteImport.update({
            id: '/founder',path: '/founder',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CharactersRoute = CharactersRouteImport.update({
            id: '/characters',path: '/characters',getParentRoute: () => rootRouteImport
          })
const AgeRatingRoute = AgeRatingRouteImport.update({
            id: '/age-rating',path: '/age-rating',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ValuesCodeRoute = ValuesCodeRouteImport.update({
            id: '/$code',path: '/$code',getParentRoute: () => ValuesRoute
          })
const ParentsSlugRoute = ParentsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ParentsRoute
          })
const CharactersCodeRoute = CharactersCodeRouteImport.update({
            id: '/$code',path: '/$code',getParentRoute: () => CharactersRoute
          })
const AuthenticatedParentConsentRoute = AuthenticatedParentConsentRouteImport.update({
            id: '/parent-consent',path: '/parent-consent',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedOnboardingRoute = AuthenticatedOnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAppRoute = AuthenticatedAppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAppIndexRoute = AuthenticatedAppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppSettingsRoute = AuthenticatedAppSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppPricingRoute = AuthenticatedAppPricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppParentRoute = AuthenticatedAppParentRouteImport.update({
            id: '/parent',path: '/parent',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppBillingRoute = AuthenticatedAppBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppAdminIndexRoute = AuthenticatedAppAdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppWatchIdRoute = AuthenticatedAppWatchIdRouteImport.update({
            id: '/watch/$id',path: '/watch/$id',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppChildNewRoute = AuthenticatedAppChildNewRouteImport.update({
            id: '/child/new',path: '/child/new',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppChildChildIdRoute = AuthenticatedAppChildChildIdRouteImport.update({
            id: '/child/$childId',path: '/child/$childId',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppAdminTeamRoute = AuthenticatedAppAdminTeamRouteImport.update({
            id: '/admin/team',path: '/admin/team',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppAdminSubscriptionsRoute = AuthenticatedAppAdminSubscriptionsRouteImport.update({
            id: '/admin/subscriptions',path: '/admin/subscriptions',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppAdminSubscribersRoute = AuthenticatedAppAdminSubscribersRouteImport.update({
            id: '/admin/subscribers',path: '/admin/subscribers',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppAdminReviewRoute = AuthenticatedAppAdminReviewRouteImport.update({
            id: '/admin/review',path: '/admin/review',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppAdminRevenueRoute = AuthenticatedAppAdminRevenueRouteImport.update({
            id: '/admin/revenue',path: '/admin/revenue',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppAdminNurtureRoute = AuthenticatedAppAdminNurtureRouteImport.update({
            id: '/admin/nurture',path: '/admin/nurture',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppAdminLaunchRoute = AuthenticatedAppAdminLaunchRouteImport.update({
            id: '/admin/launch',path: '/admin/launch',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppAdminFeedbackRoute = AuthenticatedAppAdminFeedbackRouteImport.update({
            id: '/admin/feedback',path: '/admin/feedback',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppAdminIdRoute = AuthenticatedAppAdminIdRouteImport.update({
            id: '/admin/$id',path: '/admin/$id',getParentRoute: () => AuthenticatedAppRoute
          })
const AuthenticatedAppParentTodayRoute = AuthenticatedAppParentTodayRouteImport.update({
            id: '/today',path: '/today',getParentRoute: () => AuthenticatedAppParentRoute
          })
const AuthenticatedAppParentThisWeekRoute = AuthenticatedAppParentThisWeekRouteImport.update({
            id: '/this-week',path: '/this-week',getParentRoute: () => AuthenticatedAppParentRoute
          })
const AuthenticatedAppChildChildIdStoriesRoute = AuthenticatedAppChildChildIdStoriesRouteImport.update({
            id: '/stories',path: '/stories',getParentRoute: () => AuthenticatedAppChildChildIdRoute
          })
const AuthenticatedAppChildChildIdRewardsRoute = AuthenticatedAppChildChildIdRewardsRouteImport.update({
            id: '/rewards',path: '/rewards',getParentRoute: () => AuthenticatedAppChildChildIdRoute
          })
const AuthenticatedAppChildChildIdQuietRoute = AuthenticatedAppChildChildIdQuietRouteImport.update({
            id: '/quiet',path: '/quiet',getParentRoute: () => AuthenticatedAppChildChildIdRoute
          })
const AuthenticatedAppChildChildIdJourneyRoute = AuthenticatedAppChildChildIdJourneyRouteImport.update({
            id: '/journey',path: '/journey',getParentRoute: () => AuthenticatedAppChildChildIdRoute
          })
const AuthenticatedAppChildChildIdEditRoute = AuthenticatedAppChildChildIdEditRouteImport.update({
            id: '/edit',path: '/edit',getParentRoute: () => AuthenticatedAppChildChildIdRoute
          })
const AuthenticatedAppChildChildIdChallengesRoute = AuthenticatedAppChildChildIdChallengesRouteImport.update({
            id: '/challenges',path: '/challenges',getParentRoute: () => AuthenticatedAppChildChildIdRoute
          })
const AuthenticatedAppChildChildIdStoriesStoryIdRoute = AuthenticatedAppChildChildIdStoriesStoryIdRouteImport.update({
            id: '/$storyId',path: '/$storyId',getParentRoute: () => AuthenticatedAppChildChildIdStoriesRoute
          })





const AuthenticatedAppParentRouteChildren = {
  AuthenticatedAppParentThisWeekRoute: AuthenticatedAppParentThisWeekRoute,AuthenticatedAppParentTodayRoute: AuthenticatedAppParentTodayRoute
}

const AuthenticatedAppParentRouteWithChildren = AuthenticatedAppParentRoute._addFileChildren(AuthenticatedAppParentRouteChildren)




const AuthenticatedAppChildChildIdStoriesRouteChildren = {
  AuthenticatedAppChildChildIdStoriesStoryIdRoute: AuthenticatedAppChildChildIdStoriesStoryIdRoute
}

const AuthenticatedAppChildChildIdStoriesRouteWithChildren = AuthenticatedAppChildChildIdStoriesRoute._addFileChildren(AuthenticatedAppChildChildIdStoriesRouteChildren)



const AuthenticatedAppChildChildIdRouteChildren = {
  AuthenticatedAppChildChildIdChallengesRoute: AuthenticatedAppChildChildIdChallengesRoute,AuthenticatedAppChildChildIdEditRoute: AuthenticatedAppChildChildIdEditRoute,AuthenticatedAppChildChildIdJourneyRoute: AuthenticatedAppChildChildIdJourneyRoute,AuthenticatedAppChildChildIdQuietRoute: AuthenticatedAppChildChildIdQuietRoute,AuthenticatedAppChildChildIdRewardsRoute: AuthenticatedAppChildChildIdRewardsRoute,AuthenticatedAppChildChildIdStoriesRoute: AuthenticatedAppChildChildIdStoriesRouteWithChildren
}

const AuthenticatedAppChildChildIdRouteWithChildren = AuthenticatedAppChildChildIdRoute._addFileChildren(AuthenticatedAppChildChildIdRouteChildren)



const AuthenticatedAppRouteChildren = {
  AuthenticatedAppBillingRoute: AuthenticatedAppBillingRoute,AuthenticatedAppParentRoute: AuthenticatedAppParentRouteWithChildren,AuthenticatedAppPricingRoute: AuthenticatedAppPricingRoute,AuthenticatedAppSettingsRoute: AuthenticatedAppSettingsRoute,AuthenticatedAppIndexRoute: AuthenticatedAppIndexRoute,AuthenticatedAppAdminIdRoute: AuthenticatedAppAdminIdRoute,AuthenticatedAppAdminFeedbackRoute: AuthenticatedAppAdminFeedbackRoute,AuthenticatedAppAdminLaunchRoute: AuthenticatedAppAdminLaunchRoute,AuthenticatedAppAdminNurtureRoute: AuthenticatedAppAdminNurtureRoute,AuthenticatedAppAdminRevenueRoute: AuthenticatedAppAdminRevenueRoute,AuthenticatedAppAdminReviewRoute: AuthenticatedAppAdminReviewRoute,AuthenticatedAppAdminSubscribersRoute: AuthenticatedAppAdminSubscribersRoute,AuthenticatedAppAdminSubscriptionsRoute: AuthenticatedAppAdminSubscriptionsRoute,AuthenticatedAppAdminTeamRoute: AuthenticatedAppAdminTeamRoute,AuthenticatedAppChildChildIdRoute: AuthenticatedAppChildChildIdRouteWithChildren,AuthenticatedAppChildNewRoute: AuthenticatedAppChildNewRoute,AuthenticatedAppWatchIdRoute: AuthenticatedAppWatchIdRoute,AuthenticatedAppAdminIndexRoute: AuthenticatedAppAdminIndexRoute
}

const AuthenticatedAppRouteWithChildren = AuthenticatedAppRoute._addFileChildren(AuthenticatedAppRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedAppRoute: AuthenticatedAppRouteWithChildren,AuthenticatedOnboardingRoute: AuthenticatedOnboardingRoute,AuthenticatedParentConsentRoute: AuthenticatedParentConsentRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)




const CharactersRouteChildren = {
  CharactersCodeRoute: CharactersCodeRoute
}

const CharactersRouteWithChildren = CharactersRoute._addFileChildren(CharactersRouteChildren)




const ParentsRouteChildren = {
  ParentsSlugRoute: ParentsSlugRoute
}

const ParentsRouteWithChildren = ParentsRoute._addFileChildren(ParentsRouteChildren)




const ValuesRouteChildren = {
  ValuesCodeRoute: ValuesCodeRoute
}

const ValuesRouteWithChildren = ValuesRoute._addFileChildren(ValuesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,AboutRoute: AboutRoute,AdminRoute: AdminRoute,AgeRatingRoute: AgeRatingRoute,CharactersRoute: CharactersRouteWithChildren,ContactRoute: ContactRoute,ForgotPasswordRoute: ForgotPasswordRoute,FounderRoute: FounderRoute,LoginRoute: LoginRoute,ParentsRoute: ParentsRouteWithChildren,PrivacyRoute: PrivacyRoute,RefundsRoute: RefundsRoute,ResetPasswordRoute: ResetPasswordRoute,SafetyRoute: SafetyRoute,StoryRoute: StoryRoute,SupportRoute: SupportRoute,TermsRoute: TermsRoute,UnsubscribeRoute: UnsubscribeRoute,ValuesRoute: ValuesRouteWithChildren,VisionRoute: VisionRoute,WhyRoute: WhyRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)